export default "__VITE_ASSET__BeUnA6YO__"